/**
 * Create query string from panel state
 */

export default (controlValues, searchTerm) => {
  let searchParams = new URLSearchParams();
  Object.keys(controlValues).forEach((controlDefId) => {
    searchParams.set(
      `${controlDefId}`,
      controlValues[controlDefId].map((item) => item.id).join(",")
    );
  });
  if (searchTerm) {
    searchParams.set("searchTerm", searchTerm);
  }
  return searchParams;
};
